/* =================================================================
   Sticky Add to Cart - HALO Smart Ring
   Vex Agency - Gentech Theme

   Comportamentos:
   1. Aparece SOMENTE quando o botao principal de ATC sai por cima da viewport
   2. Some quando o FOOTER aparece (nao cobre o rodape)
   3. Sincroniza preco, variante e imagem ao trocar opcoes
   4. Adiciona ao carrinho ao clicar no CTA da bar
   5. Volta ao topo do produto ao clicar na thumb

   Sem dependencias. Vanilla JS puro.
================================================================= */

class StickyAddToCart {
  constructor() {
    this.bar = document.querySelector('[data-sticky-atc]');
    if (!this.bar) return;

    this.productForm = document.querySelector(
      'product-form, [data-product-form], form[action*="/cart/add"]'
    );

    this.mainCTA = this.productForm
      ? this.productForm.querySelector('[type="submit"], [name="add"]')
      : null;

    if (!this.mainCTA) {
      console.warn('[sticky-atc] Botao principal de adicionar ao carrinho nao encontrado.');
      return;
    }

    this.elements = {
      title: this.bar.querySelector('[data-sticky-atc-title]'),
      variant: this.bar.querySelector('[data-sticky-atc-variant]'),
      price: this.bar.querySelector('[data-sticky-atc-price]'),
      compare: this.bar.querySelector('[data-sticky-atc-compare]'),
      submit: this.bar.querySelector('[data-sticky-atc-submit]'),
      ctaText: this.bar.querySelector('[data-sticky-atc-cta-text]'),
      thumb: this.bar.querySelector('[data-sticky-atc-scroll-top]')
    };

    this.productHandle = this.bar.dataset.productHandle;
    this.sectionId = this.bar.dataset.sectionId;
    this.defaultCtaText = this.elements.ctaText
      ? this.elements.ctaText.textContent.trim()
      : 'Comprar agora';

    this.init();
  }

  init() {
    this.setupVisibility();
    this.setupSubmit();
    this.setupScrollTop();
    this.setupVariantSync();
  }

  /* =============================================================
     Mostrar / esconder a bar com base no scroll
     Regra: aparece quando o botao principal de ATC ja saiu por
     cima da viewport E o footer ainda NAO esta visivel.
  ============================================================= */
  setupVisibility() {
    var self = this;
    this._pastCTA = false;
    this._footerVisible = false;

    var apply = function () {
      if (self._pastCTA && !self._footerVisible) self.show();
      else self.hide();
    };

    // Botao principal de ATC
    var ctaObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      self._pastCTA = (!entry.isIntersecting && entry.boundingClientRect.top < 0);
      apply();
    }, { threshold: 0 });
    ctaObserver.observe(this.mainCTA);

    // Footer: quando entra na tela, esconde a bar (nao cobrir o rodape)
    var footer = document.querySelector('.xo-section-footer, .shopify-section-group-footer-group, footer');
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        self._footerVisible = entries[0].isIntersecting;
        apply();
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  }

  show() {
    this.bar.classList.add('is-visible');
    this.bar.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-sticky-atc');
  }

  hide() {
    this.bar.classList.remove('is-visible');
    this.bar.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-sticky-atc');
  }

  /* =============================================================
     Click no CTA da bar = aciona o botao principal
  ============================================================= */
  setupSubmit() {
    if (!this.elements.submit) return;

    this.elements.submit.addEventListener('click', (e) => {
      e.preventDefault();
      this.elements.submit.classList.add('is-loading');

      if (this.productForm) {
        if (typeof this.productForm.onSubmitHandler === 'function') {
          const fakeEvent = new Event('submit', { cancelable: true });
          this.productForm.onSubmitHandler(fakeEvent);
        } else {
          this.mainCTA.click();
        }
      } else {
        this.mainCTA.click();
      }

      setTimeout(() => {
        this.elements.submit.classList.remove('is-loading');
        this.elements.submit.classList.add('is-success');
        if (this.elements.ctaText) {
          this.elements.ctaText.textContent = 'Adicionado ✓';
        }
        setTimeout(() => {
          this.elements.submit.classList.remove('is-success');
          if (this.elements.ctaText) {
            this.elements.ctaText.textContent = this.defaultCtaText;
          }
        }, 1800);
      }, 800);
    });
  }

  /* =============================================================
     Click na thumb = volta ao topo do produto
  ============================================================= */
  setupScrollTop() {
    if (!this.elements.thumb) return;

    this.elements.thumb.addEventListener('click', (e) => {
      e.preventDefault();
      const productSection = document.querySelector(
        '.product, [data-product], #MainProduct, main'
      );
      if (productSection) {
        productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  /* =============================================================
     Sincroniza com troca de variantes
  ============================================================= */
  setupVariantSync() {
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail && e.detail.variant;
      if (variant) {
        this.updateVariant(variant);
      }
    });

    const variantInput = document.querySelector(
      'input[name="id"][type="hidden"], select[name="id"]'
    );

    if (variantInput) {
      variantInput.addEventListener('change', () => {
        this.fetchAndUpdateVariant(variantInput.value);
      });
    }
  }

  updateVariant(variant) {
    if (!variant) return;

    if (this.elements.variant) {
      this.elements.variant.textContent = variant.title || '';
    }

    if (this.elements.price) {
      this.elements.price.textContent = this.formatMoney(variant.price);
    }

    if (this.elements.compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.elements.compare.textContent = this.formatMoney(variant.compare_at_price);
        this.elements.compare.removeAttribute('hidden');
      } else {
        this.elements.compare.setAttribute('hidden', '');
      }
    }

    if (this.elements.submit) {
      if (variant.available === false) {
        this.elements.submit.setAttribute('disabled', '');
        if (this.elements.ctaText) {
          this.elements.ctaText.textContent = 'Esgotado';
        }
      } else {
        this.elements.submit.removeAttribute('disabled');
        if (this.elements.ctaText) {
          this.elements.ctaText.textContent = this.defaultCtaText;
        }
      }
    }

    if (variant.featured_image && this.elements.thumb) {
      const img = this.elements.thumb.querySelector('img');
      if (img) {
        const newSrc = variant.featured_image.src
          ? this.resizeImage(variant.featured_image.src, 120)
          : variant.featured_image;
        if (newSrc) img.src = newSrc;
      }
    }
  }

  fetchAndUpdateVariant(variantId) {
    if (!variantId || !this.productHandle) return;

    fetch(`/products/${this.productHandle}.js`)
      .then(r => r.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
          this.updateVariant(variant);
        }
      })
      .catch(err => console.warn('[sticky-atc] Falha ao buscar variante:', err));
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  resizeImage(src, width) {
    if (!src) return src;
    return src.replace(/(\.[a-z0-9]+)(\?|$)/i, `_${width}x$1$2`);
  }
}

/* =================================================================
   Inicializacao
================================================================= */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new StickyAddToCart());
} else {
  new StickyAddToCart();
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[data-sticky-atc]')) {
    new StickyAddToCart();
  }
});